import type { ThemeColor } from "@/colors";
import { p } from "@/utils/props-builder";

export const colorProp = p.string<ThemeColor>("brand");

export type Size = "sm" | "md" | "lg" | "xs";
export const sizeProp = p.string<Size>("md");

export type RoundedOption = "none" | "sm" | "md" | "lg" | "full";
export const radiusProp = p.string<RoundedOption>("md");

export type InputVariant = "default" | "filled" | "ghost";
export const variantProp = p.string<InputVariant>("default");
